import React, { useEffect, useState } from 'react';
import { Line } from "react-chartjs-2";
import {
  Card, CardBody, CardHeader, Col, Row
} from "reactstrap";
import { chartColors } from '../constants';

const TotalExecutionsChart: React.FC<{
  title: string;
  data?: {
    count: number
    day: string
  }[];
  isLoading?: boolean
}> = ({ isLoading, data, title }) => {

  const [chartData, setChartData] = useState<Chart.ChartData>()

  useEffect(() => {
    if (!isLoading && data) {
      setChartData({
        labels: data.map(({ day }) => day),
        datasets: [
          {
            label: title,
            data: data.map(({ count }) => count)
          }
        ]
      })

    }
  }, [data, isLoading, title])

  return (
    <Row className="mt-5">
      <Col className="mb-xl-0">
        <Card className="bg-gradient-default shadow">
          <CardHeader className="bg-transparent">
            <Row className="align-items-center">
              <div className="col">
                <h6 className="text-uppercase text-light ls-1 mb-1">
                  Overview
                </h6>
                <h2 className="text-white mb-0">{title}</h2>
              </div>
            </Row>
          </CardHeader>
          <CardBody>
            {
              !chartData ?
                <div>Please Wait</div>
                :
                <div className="chart">
                  <Line
                    data={chartData}
                    options={{
                      legend: {
                        display: false,
                        position: "bottom",
                        labels: {
                          usePointStyle: true,
                          padding: 16,
                        },
                      },
                      elements: {
                        point: {
                          radius: 0,
                          backgroundColor: chartColors.theme["primary"],
                        },
                        line: {
                          tension: 0.4,
                          borderWidth: 4,
                          borderColor: chartColors.theme["primary"],
                          backgroundColor: chartColors.transparent,
                          borderCapStyle: "rounded",
                        },
                        rectangle: {
                          backgroundColor: chartColors.theme["warning"],
                        },
                        arc: {
                          backgroundColor: chartColors.theme["primary"],
                          borderColor: chartColors.white,
                          borderWidth: 4,
                        },
                      },
                      defaultColor: chartColors.gray[600],
                      layout: {
                        padding: 0,
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                      scales: {
                        xAxes: [
                          {
                            ticks: {
                              fontColor: chartColors.gray[600],
                              beginAtZero: true,
                            },
                          },
                        ],
                        yAxes: [
                          {
                            gridLines: {
                              color: chartColors.gray[900],
                              zeroLineColor: chartColors.gray[900],
                            },
                            ticks: {
                              beginAtZero: true,
                              fontColor: chartColors.gray[600],
                              callback: function (value) {
                                return value;
                              },
                            },
                          },
                        ],
                      },
                      tooltips: {
                        enabled: true,
                        mode: "index",
                        intersect: false,
                        callbacks: {
                          label: (item, data) => {
                            return `${item.yLabel || 0} ${title}`
                          },
                        },
                      },
                    }}
                  />
                </div>
            }
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default TotalExecutionsChart
